export const MODULE_NAME = 'Lawsuits'

export const paths = {
  lawsuits: '/lawsuits',
  lawyerLawsuits: '/lawyer/lawsuits',
  circumstances: '/lawsuits/new/circumstances',
  documents: '/lawsuits/new/documents',
  parties: '/lawsuits/new/parties',
  summary: '/lawsuits/new/summary',
  success: '/lawsuits/new/success',
}
